<div class="padding">
    <div class="gry-back-ground">
        <div class="white-back-ground">
            <div class="row mobprelative">
                <div class="col-xl-4 col-md-4">
                    <div style="display: flex;">
                        <div class="img-container">
                            <div class="back-img">
                                <img class="img-mobile-size"
                                    [src]="orderDetails?.restaurantData[0]?.logo ? orderDetails?.restaurantData[0]?.logo : '../../../../assets/image/Group 1261153964.svg'"
                                    height="74" width="74" style="border-radius: 10px;">
                            </div>
                        </div>

                        <div class="rest-details">
                            <div class="rest-text" style="overflow-wrap: anywhere;">
                                {{orderDetails?.restaurantData[0]?.restaurantName}}
                            </div>
                            <div class="gourmet-text">
                                <!-- Gourmet Fries
                                <span><img class="span-img"
                                        src="../../../../assets/icon/Frame1261153957.png"></span> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-md-4 usgamebloc" style="    padding-top: 15px;">
                    <div>
                        <div class="usgame-text">{{orderDetails?.eventData[0]?.eventTitle}}</div>
                    </div>
                    <div class="june-time-text">
                        <div class="june-text">
                            <img class="cal-time-img" src="../../../../assets/icon/cal.png">
                            <span>{{orderDetails?.eventData[0]?.eventDate | date:'MMM dd, YYYY': 'UTC'}}</span>
                        </div>
                        <div class="time-text">
                            <img class="cal-time-img" src="../../../../assets/icon/TimeCircle.png">
                            <span>{{formatEventTime(orderDetails?.eventData[0]?.eventDateTime)}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <hr *ngIf="paidItems?.length>0">


            <div class="order-item-delivary">
                <div class="">
                    <div class="order-id-line" *ngFor="let j of paidItems">
                        <div class="order-text text-quentity">
                            {{j.productData?.productName}}
                            <span class="productQty">x{{j?.quantity-j?.isFreeQuantity}}</span>
                        </div>
                        <div class="order-id">
                            $ {{convertToDecimal(orderDetails?.coachFreeMeal ? 0 : j.productData?.productPrice *
                            (j?.quantity-j?.isFreeQuantity))}}
                        </div>
                    </div>
                </div>
            </div>
            <hr>

            <div class="order-item-delivary">
                <div class="order-id-line">
                    <div class="order-text">
                        Order ID
                    </div>

                    <div class="order-id" style="font-weight: 400;">
                        {{orderDetails?.orderId}}
                    </div>
                </div>

                <div class="order-id-line">
                    <div class="order-text">
                        Item Total
                    </div>

                    <div class="order-id">
                        $ {{convertToDecimal( orderDetails?.coachFreeMeal==true ? 0 :(orderDetails?.itemsAmount ?
                        orderDetails?.itemsAmount : orderDetails?.totalAmount))}}
                    </div>
                </div>

                <div class="order-id-line" *ngIf="orderDetails?.deliveryCharges">
                    <div class="order-text">
                        Delivery Charges
                    </div>

                    <div class="order-id">
                        <span *ngIf="orderDetails?.restaurantData[0]?.isFreeDelivery == false"></span>
                        {{orderDetails?.deliveryCharges ? '$ '+ convertToDecimal(orderDetails?.deliveryCharges) : 'Free'
                        }}
                    </div>
                </div>

                <div class="order-id-line" *ngIf="orderDetails?.taxAmount && orderDetails?.taxAmount>0">
                    <div class="order-text">
                        Tax & Fees
                    </div>

                    <div class="order-id">
                        <span></span>
                        {{'$ '+ convertToDecimal(orderDetails?.taxAmount) }}
                    </div>
                </div>
            </div>

            <hr>


            <div class="order-id-line">
                <div class="order-text totalamnt" style="margin-bottom: 26px;">
                    Total Amount Payable
                </div>

                <div class="order-id">
                    $ {{convertToDecimal(orderDetails?.totalAmount) }}
                </div>
            </div>

            <!-- <div style="margin-top: 20px;">
                <div class="john-doe-img">
                    <span><img src="../../../../assets/authImg/Ellipse 23069.jpg"></span>
                    <div class="john-text">John Doe</div>
                </div>
            </div> -->

            <div style="margin-top: 15px;">
                <div class="order-price-text">
                    Order Price
                </div>
            </div>

            <div class="paid-btn">
                <div class="amount-paid">
                    <div class="amount-text d-flex align-items-center">
                        $ {{convertToDecimal(orderDetails?.totalAmount)}}
                        <span class="pandding me-3 ms-3"
                            *ngIf="orderDetails?.isCancelled==true && !orderDetails?.isDeclined">
                            Canceled
                        </span>

                        <!-- [ngClass]="{'paid':orderDetails?.isPaymentDone==true,'pandding':orderDetails?.isPaymentDone==false}" -->
                        <span class=" me-3 ms-3 paid"
                            *ngIf="orderDetails?.isCancelled==false && !orderDetails?.isDeclined">
                            <!-- {{orderDetails?.isPaymentDone==true ? 'Paid': 'Pending'}} -->

                            <span *ngIf="(currentUser?.userDetails?.userType == 2  || this.currentUser.userType==2)">
                                <span *ngIf="orderDetails?.isPaymentDone">Paid</span>
                            </span>

                            <span *ngIf="(currentUser?.userDetails?.userType == 3  || this.currentUser.userType==3)">
                                <span *ngIf="orderDetails?.isPaymentDone">{{orderDetails?.isPaidBy == 2 ? 'Paid By
                                    Coach' : 'Paid'}}</span>
                            </span>

                            <!-- <span *ngIf="i?.isPaymentDone">{{i?.isPaymentDone == true ? 'Paid': 'Pending'}}</span> -->
                            <span *ngIf="!orderDetails?.isPaymentDone">Pending</span>

                        </span>

                        <span class=" me-3 ms-3 paid" *ngIf="orderDetails?.isDeclined">
                            Declined
                        </span>
                    </div>
                    <!-- <div class="paid" *ngIf="type==2">
                        Paid by Coach
                    </div> -->
                </div>
            </div>


        </div>
    </div>
</div>